import { rublesToKopeiki, unformatValue } from "./utils";
export var getSumInKopeiki = function getSumInKopeiki(state) {
  var sum = Number(unformatValue(state.sumInput.value));
  return rublesToKopeiki(sum) || 0;
};